const map = {
	"./ar/chat.json": [
		32308,
		[
			2308
		]
	],
	"./de/chat.json": [
		94584,
		[
			4584
		]
	],
	"./en/chat.json": [
		27236,
		[
			7236
		]
	],
	"./es/chat.json": [
		13309,
		[
			3309
		]
	],
	"./fa/chat.json": [
		34042,
		[]
	],
	"./fr/chat.json": [
		52389,
		[
			2389
		]
	],
	"./ja/chat.json": [
		614,
		[
			614
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42442;
module.exports = webpackAsyncContext;